import React, { FunctionComponent } from "react";
import Breadcrumb from "../components/Breadcrumb";
import GridQuestionSection from "../components/GridQuestionSection";
import SearchBar from "../components/searchbar/SearchBar";
import { DefaultFAQPagesProps, IHelpQuestionSection } from "../interfaces";

interface StaticBloc {
  url: string;
  img: string;
  alt: string;
  title: string;
}

interface HomeFAQProps extends DefaultFAQPagesProps {
  staticBlocs: StaticBloc[];
  items: IHelpQuestionSection[];
  h1: string;
  staticContents?: Record<string, string>;
}

const HomeFAQ: FunctionComponent<HomeFAQProps> = ({
  shopInfos,
  langId,
  hostApi,
  staticBlocs,
  breadcrumbHomeIcon,
  breadcrumbSeparatorIcon,
  items,
  h1,
  staticContents,
  baseLangUrl
}) => {

  return (
    <div className={"container faq " + shopInfos.Ref}>
      <Breadcrumb
        homeIcon={breadcrumbHomeIcon}
        separatorIcon={breadcrumbSeparatorIcon}
        baseLangUrl={baseLangUrl}
        items={[
          {
            title: h1,
          },
        ]}
      />
      <div className="display-flex flex-column align-items-center justify-content-center">
        <h1 className="titre-page h2 bold">{h1}</h1>
        <p className="mt-1">{staticContents?.['TEXT_SEARCHBAR']}</p>
        <SearchBar hostApi={hostApi} langId={langId} shopId={shopInfos.idBoutique} placeholder={staticContents?.['PLACEHOLDER_SEARCHBAR']} />
      </div>
      <h2 className="faq-sub-title font20 bold">{staticContents?.['SUBTITLE_1']}</h2>
      <GridQuestionSection
        hostApi={hostApi}
        shopInfos={shopInfos}
        items={items}
        textButtonSeeThematic={staticContents?.['TEXT_BUTTON_SEE_TOPICS'] ?? ''}
        baseLangUrl={baseLangUrl}
      />
      <hr className="faq-hr-h mt-4 mb-4" />
      <h2 className="faq-sub-title font20 bold mt-3">{staticContents?.['SUBTITLE_2']}</h2>
      <section className="faq-infos-sections mt-4">
        {staticBlocs.map((item, i) => (
          <a
            className="faq-info-box display-flex flex-column font14 bold p-3 text-decoration-none align-items-center text-black"
            href={item.url}
            key={i}
          >
            {item.title}
            <img src={item.img} height="50" alt={item.alt} />
          </a>
        ))}
      </section>
    </div>
  );
};

export default HomeFAQ;
